import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Button,
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem,
  Pagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  PaginationItem,
  Drawer,
  Alert,
  Snackbar,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AddLogisticsVendorMaster from "./AddLogisticsVendorMaster";
import UserDateFilter from "../../../Roles and Permissions/Filters/UserFilters/UserDateFilter";
import { api, get, del } from "../../../../../utils/api";
import FilterSidebar from "../../../../../Components/Masters/Filter/FilterSidebar";
import ApplyButton from "../../../Roles and Permissions/Filters/ApplyButton";
import CountryFilter from "../../../Roles and Permissions/Filters/UserFilters/CountryFilter";
import ResetButton from "../../../Roles and Permissions/Filters/ResetButton";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { styled } from "@mui/material/styles";
import ViewVendor from "./ViewLogisticsVendorMaster";
import NoDataFound from "../../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../../Layout/MastersSidebar";
import { useUser } from "../../../../../context/AuthContext";
import Unauthorized from "../../../../../Components/Unauthorized/Unauthorized";
import {FacilityColumnHeading,
  facilityDataCellSx,
  getFacilityName,
  shouldShowFacilityColumn, FacilityDataCell, MasterDateDataCell } from "../../../../../utils/facilityColumn";

const LogisticsVendorMaster = ({ url }) => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const columnWidth = showFacilityColumn
    ? "11% 11% 14% 17% 15% 16% 10%"
    : "13% 22% 16% 20% 20% 10%";

  const [logesticVendors, setLogesticVendors] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLogestic, setSelectedLogestic] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addVendor, setAddVendor] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Country: false,
  });
  const [viewVendor, setViewVendor] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState([]); // Store selected countries
  const [selectedEqupments, setSelectedEquipments] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [errors, setErrors] = useState({
    Date: false,
    Country: false,
  });

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    selectedCountries: [],
  });

  const filters = ["Date", "Country"];

  url = url ? url : `${api}/master`;

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <UserDateFilter
            startDate={tempFilter.startDate}
            endDate={tempFilter.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );

      case "Country":
        return (
          <CountryFilter
            url={`${url}/logistic/vendorMaster`}
            selectedCountries={tempFilter?.selectedCountries}
            setSelectedCountries={(countries) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedCountries: countries,
              }))
            }
            setErrors={setErrors}
            errors={errors.Country}
          />
        );
      default:
        return null;
    }
  };

  const handleMenuClick = (event, logesticVendors) => {
    setAnchorEl(event.currentTarget);
    setSelectedLogestic(logesticVendors);
    setdataView(logesticVendors);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedLogestic(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddVendor(true);
    setViewVendor(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewVendor(true);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleDeleteAggree = async () => {
    await del(`${url}/logistic/vendorMasterDelete?Id=${dataView?._id}`)
      .then((res) => {
        setDeleteDialog(false);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchLogesticVendor();
      })
      .catch((err) => {
        console.log(err, "err+++++");
        setsnackOpen({
          open: true,
          message: err.response?.data.message ?? "network Error",
          severity: "error",
        });
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // fetching  data
  const fetchLogesticVendor = async (filters = filtersToApply) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: rowsPerPage,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();

      await get(`${url}/logistic/vendorMaster?${queryParams}`)
        .then((res) => {
          if (res?.data?.data) {
            setLogesticVendors(res.data.data);
            setTotalPages(res.data.totalPages);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchLogesticVendor();
  }, [page, rowsPerPage, sortConfig]);

  // default filters to apply
  const filtersToApply = {
    country: tempFilter?.selectedCountries.join(","),
    //  brand: selectedEqupments.join(","),
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = { Date: "", Country: "" };
    if (selectedFilter === "Date") {
      if (startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    setPage(1);
    setIsFiltersApplied(true);
    setSelectedCountries(tempFilter?.selectedCountries);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setDrawerFilterOpen(false);
    handleAppliedFilters();
    fetchLogesticVendor();
  };

  const handleResetFilters = () => {
    setTempFilter({
      selectedCountries: [],
      startDate: null,
      endDate: null,
    });
    setSelectedCountries([]);
    setStartDate(null);
    setEndDate(null);
    setIsFiltersApplied(false);
    setAppliedFilters({ Facility: false, Date: false, Country: false });
    setErrors({});
    fetchLogesticVendor({
      country: [],
      startDate: "",
      endDate: "",
    });
    setDrawerFilterOpen(false);
  };

  // handle the applied filters for styling
  const handleAppliedFilters = () => {
    setAppliedFilters({
      ...appliedFilters,
      Date: tempFilter?.startDate || tempFilter?.endDate ? true : false,
      Country: tempFilter?.selectedCountries.length > 0 ? true : false,
    });
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setDrawerFilterOpen(false);
    // if (!isFiltersApplied) {
    //   handleResetFilters();
    // }
    // setErrors({ Date: false, Role: false });
  };

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
            width: "100%",
          }}
        >
          <Snackbar
            open={snackOpen.open}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          >
            <Alert
              // onClose={handleClose}
              severity={snackOpen.severity}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {snackOpen.message}
              {/* Add user Successfully */}
            </Alert>
          </Snackbar>
          <AddLogisticsVendorMaster
            setAddVendor={setAddVendor}
            fetchLogesticVendor={fetchLogesticVendor}
            setsnackOpen={setsnackOpen}
            addVendor={addVendor}
            selectedLogestic={dataView}
            url={url}
          />
          <ViewVendor
            viewVendor={viewVendor}
            setViewVendor={setViewVendor}
            selectedLogestic={dataView}
            handleEdit={handleEdit}
          />
          {deleteDialog && (
            <Dialog open={deleteDialog}>
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you really want to delete this entry?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  // sx={{ textTransform: "none" }}
                  onClick={() => setDeleteDialog(false)}
                  color="primary"
                >
                  Cancel
                </Button>
                <Button
                  // sx={{ textTransform: "none" }}
                  onClick={handleDeleteAggree}
                  color="secondary"
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {/* <Toolbar sx={{ marginBottom: "20px" }}> */}
          {drawerFilterOpen && (
            <Drawer
              anchor="right"
              open={drawerFilterOpen}
              onClose={() => {
                setTempFilter({
                  startDate: startDate,
                  endDate: endDate,
                  selectedCountries: selectedCountries,
                });
                handleFilterDrawer();
              }}
              sx={{
                backgroundColor: "transparent",
                "& .MuiDrawer-paper": {
                  // This targets the paper component within the Drawer
                  backgroundColor: "transparent", // Make paper transparent
                  boxShadow: "none", // Optional: Remove any shadow
                  width: "50%",
                },
              }}
            >
              <Box
                display="flex"
                gap={3}
                sx={{
                  width: "100%",
                  display: "flex",
                  overflowX: "hidden",
                  maxWidth: "100%",
                  justifyContent: "space-btween",
                  height: "100%",
                  backgroundColor: "transparent",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#f5f5f5",
                    height: "3%",
                    padding: "13px",
                    margin: "30px 0 0 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "80%",
                    width: "3%",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      setTempFilter({
                        startDate: startDate,
                        endDate: endDate,
                        selectedCountries: selectedCountries,
                      });
                      handleFilterDrawer();
                    }}
                    sx={{ color: "black" }}
                  >
                    <CloseIcon sx={{ fontSize: "1.2rem" }} />
                  </IconButton>
                </Box>
                <Box sx={{ display: "flex", width: "100%", height: "100vh" }}>
                  {/* Sidebar for selecting the filter */}
                  <FilterSidebar
                    {...{
                      setSelectedFilter,
                      selectedFilter,
                      filters,
                      appliedFilters,
                    }}
                  />

                  {/* Filter content area */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      backgroundColor: "#F9F9F9",
                      padding: "20px",
                      overflowY: "scroll",
                    }}
                  >
                    {renderSelectedFilter()}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        gap: "3%",
                        position: "fixed",
                        bottom: "20px",
                        ml: 3,
                        mr: 3,
                      }}
                    >
                      <ApplyButton handleApply={handleApplyFilters} />
                      <ResetButton handleReset={handleResetFilters} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Drawer>
          )}{" "}
          <Box
            sx={{
              pt: "2rem",
              // display: "flex",
              // justifyContent: "space-between",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <Box
              item
              xs={6}
              sx={{
                // marginLeft: "-1.5rem",
                // marginTop: "-0.6rem",
                display: "flex",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                {url.includes("scope1") ? "Scope 1" : "Scope 3"}
              </Typography>
            </Box>
            <Box
              item
              xs={6}
              sx={{
                display: "flex",
                gap: "0.6rem",
                my: "1rem",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                onClick={() => setDrawerFilterOpen(true)}
                // endIcon={<FilterListIcon />}
                sx={{
                  // margin: "10px 10px -15px 0px",
                  backgroundColor: "#ffffff",
                  color: "black",
                  "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                  "&:hover .dot-icon": {
                    color: "#FFFFFF", // Change dot color on button hover
                  },
                  // display:"flex"
                }}
              >
                Filter
                <FilterListIcon />
                {(tempFilter?.selectedCountries.length > 0 ||
                  tempFilter?.startDate ||
                  tempFilter?.endDate) && (
                  <FiberManualRecordIcon
                    className="dot-icon"
                    sx={{
                      fontSize: "10px",
                      color: "#488257",
                      marginLeft: "5px",
                    }}
                  />
                )}
              </Button>

              {!user?.companyAdmin ? (
                <Button
                  variant="contained"
                  endIcon={<AddIcon />}
                  sx={{
                    backgroundColor: "#1c486b",
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddVendor(true);
                    setdataView(null);
                  }}
                >
                  Add New
                </Button>
              ) : null}
            </Box>
          </Box>
          {/* </Toolbar> */}
          <TableContainer
            component={Paper}
            sx={{ flex: 1, overflow: "hidden", mt: "1.5rem" }}
          >
            <Box>
              <Box sx={{ margin: "16px" }}>
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "left",
                    // padding: "0px",
                  }}
                >
                  Logistics Vendor Master
                </Box>
              </Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  ...(showFacilityColumn && { alignItems: "stretch" }),
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 16px",
                    // marginBottom:
                    //   logesticVendors?.length === 0 ? "0px" : "-10px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Date
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("createdAt", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("createdAt", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>

                {showFacilityColumn && (
                  <FacilityColumnHeading
                    handleSort={handleSort}
                    sortConfig={sortConfig}
                  />
                )}

                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    // marginBottom:
                    //   logesticVendors?.length === 0 ? "0px" : "-10px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Logistics Vendor
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() =>
                        handleSort("logisticVendorLegalName", "asc")
                      }
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "logisticVendorLegalName" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() =>
                        handleSort("logisticVendorLegalName", "desc")
                      }
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "logisticVendorLegalName" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Contact Person
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("contactPersonName", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "contactPersonName" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("contactPersonName", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "contactPersonName" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    // marginBottom:
                    //   logesticVendors?.length === 0 ? "0px" : "-10px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Country
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("country", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "country" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("country", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "country" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                          color: "black",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    // marginBottom:
                    //   logesticVendors?.length === 0 ? "0px" : "-10px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Mobile Number
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("contactPersonMobile", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "contactPersonMobile" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                          color: "black",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("contactPersonMobile", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "contactPersonMobile" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                          color: "black",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>

                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    // marginBottom:
                    //   logesticVendors?.length === 0 ? "0px" : "-10px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  Action
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  ></Box>
                </Typography>
              </Box>
              {logesticVendors.length === 0 ? (
                <NoDataFound />
              ) : (
                logesticVendors.map((logesticVendors) => (
                  <Box
                    key={logesticVendors._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: columnWidth,
                      ...(showFacilityColumn && { alignItems: "stretch" }),
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <Typography
                      sx={{
                        padding: "8px 16px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {/* {new Date(logesticVendors.createdAt).toLocaleDateString()} */}
                      {new Date(logesticVendors.createdAt).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        }
                      )}
                    </Typography>

                    {showFacilityColumn && (
                      <FacilityDataCell>
                        {getFacilityName(logesticVendors) || "N/A"}
                      </FacilityDataCell>
                    )}

                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {logesticVendors.logisticVendorLegalName}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {logesticVendors.contactPersonName}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {logesticVendors.country}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {logesticVendors.contactPersonMobile}
                    </Typography>
                    <Box
                      sx={{
                        padding: "1px",
                        textAlign: "center",
                      }}
                    >
                      <IconButton
                        onClick={(e) => handleMenuClick(e, logesticVendors)}
                      >
                        <MoreHorizIcon
                          sx={{ fontWeight: "bold", color: "black" }}
                        />
                      </IconButton>
                    </Box>
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* </TableContainer> */}
          {/* Pagination */}
          {totalPages > 1 && (
            <Box
              sx={{ display: "flex", justifyContent: "center", width: "101%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 3,
                  backgroundColor: "#ffffff",
                  width: "100%",
                  borderRadius: "2%",
                  padding: "4px",
                  marginBottom: "1rem",
                }}
              >
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={handleChangePage}
                  renderItem={(item) => (
                    <StyledPaginationItem
                      // <PaginationItem
                      {...item}
                      components={{
                        previous: () => (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mr: 27,
                            }}
                          >
                            <ArrowBackIcon sx={{ mr: 0.5, color: "green" }} />
                            Previous
                          </Box>
                        ),
                        next: () => (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              ml: 27,
                            }}
                          >
                            Next
                            <ArrowForwardIcon
                              sx={{ ml: 0.5, color: "green" }}
                            />
                          </Box>
                        ),
                      }}
                      sx={{
                        "& .MuiPaginationItem-root": {
                          mx: 1,
                        },
                        "& .MuiPagination-ul": {
                          display: "flex",
                          alignItems: "center",
                        },
                      }}
                    />
                  )}
                />
              </Box>
            </Box>
          )}
          {/* Menu for Actions */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              sx: {
                width: "120px",
                border: "1px solid #ddd",
                marginLeft: "-47px",
              },
            }}
          >
            {user?.companyAdmin ? (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
              </>
            ) : (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
                <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
                  <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Edit
                </MenuItem>
                <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
                  <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Delete
                </MenuItem>
              </>
            )}
          </Menu>
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default LogisticsVendorMaster;
